import { render, staticRenderFns } from "./PortArea.vue?vue&type=template&id=cd1b8fa4&scoped=true&"
import script from "./PortArea.vue?vue&type=script&lang=js&"
export * from "./PortArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b8fa4",
  null
  
)

export default component.exports